<script lang="ts">
  import { onMount } from 'svelte'
  import Lobby from './Lobby/Lobby.svelte'
  import Review from './Review.svelte'
  import { state } from './State'
  import Vote from './Vote/Vote.svelte'
  import { add_self_to_lobby, in_retro } from '../Players/observables'
  import type { RetroAuthedUser } from '../Users/types'
  import PreLobby from './PreLobby.svelte'
  import { Modal as UnTypedModal } from 'svelte-simple-modal'
  import { SvelteComponentTyped } from 'svelte'
  export let user: RetroAuthedUser

  const Modal = UnTypedModal as unknown as new (...args: any) => SvelteComponentTyped

  onMount(() => {
    void $add_self_to_lobby()
  })
</script>

<Modal>
  {#if $state === undefined || $in_retro === undefined}
    <p>Loading...</p>
  {:else if !$in_retro}
    <PreLobby org_uid={user.organization} />
  {:else if $state.phase === 'lobby'}
    <Lobby {user} />
  {:else if $state.phase === 'vote'}
    <Vote {user} />
  {:else if $state.phase === 'review'}
    <Review {user} />
  {/if}
</Modal>
